import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { useAuthenticationFactorListContext } from '../AuthenticationFactorListContext';
import { getTemplate } from './Templates';

export const FormLayout = () => {
  const { clearModalLink, refreshListCollection } = useAuthenticationFactorListContext();
  const { resource } = useMetaLayoutContext();

  const Layout = getTemplate(resource);

  return (
    <Layout
      onSuccess={() => {
        clearModalLink();
        refreshListCollection();
      }}
    />
  );
};
